import React from 'react';
import Box from "@amzn/meridian/box";
import Column from "@amzn/meridian/column";
import StationPerformanceSummary from "./StationPerformanceSummary";
import InboundFilter from "./InboundFilter";

const InboundOverview = () => {
    return (
        <Column>
            <InboundFilter />
            <Box>
                <StationPerformanceSummary />
            </Box>
        </Column>
    )
}

export default InboundOverview;



// WEBPACK FOOTER //
// ./src/components/inbound/InboundOverview.js